export const recaptchaSiteKey: string =
    process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '6LfvMrMoAAAAAC2yDzFvMnr2eiAjHmVLzHkuv7k1';
